module.exports = __webpack_public_path__ + "media/images/mobile/solutions/36-f9234b9bbabf0a26f9a3881f124bf627.jpg";